import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../../data-structures/results/result-row.model";

/**
 * operational and performance parameter
 */
interface OAPPInterface {
 'RESULTS.DATA.TECHNICAL.HRT'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.OLR'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.DWV'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.DTV'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.BEE'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.AMF'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.ABF'?: ResultRow;
}
export class OAPP {
  'RESULTS.DATA.TECHNICAL.HRT';
  'RESULTS.DATA.TECHNICAL.OLR';
  'RESULTS.DATA.TECHNICAL.DWV';
  'RESULTS.DATA.TECHNICAL.DTV';
  'RESULTS.DATA.TECHNICAL.BEE';
  'RESULTS.DATA.TECHNICAL.AMF';
  'RESULTS.DATA.TECHNICAL.ABF';
  /** hydraulic retention time */
  get hrt() {
    return this['RESULTS.DATA.TECHNICAL.HRT'];
  }
  set hrt(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.HRT'] = value;
  }
  /** organic loading rate */
  get olr() {
    return this['RESULTS.DATA.TECHNICAL.OLR'];
  }
  set olr(value: ResultRow) {
    value = this['RESULTS.DATA.TECHNICAL.OLR'];
  }
  /** Digester Working Volume */
  get dwv() {
    return this['RESULTS.DATA.TECHNICAL.DWV'];
  }
  set dwv(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.DWV'] = value;
  }
  /** digester total volume */
  get dtv() {
    return this['RESULTS.DATA.TECHNICAL.DTV'];
  }
  set dtv(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.DTV'] = value;
  }
  /** biogas extraction efficiency */
  get bee() {
    return this['RESULTS.DATA.TECHNICAL.BEE'];
  }
  set bee(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.BEE'] = value;
  }
  /** amount of methane flared */
  get amf() {
    return this['RESULTS.DATA.TECHNICAL.AMF'];
  }
  set amf(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.AMF'] = value;
  }
  /** amount of biogas flared */
  get abf() {
    return this['RESULTS.DATA.TECHNICAL.ABF'];
  }
  set abf(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.ABF'] = value;
  }

  constructor(param: OAPPInterface = {}) {
    this['RESULTS.DATA.TECHNICAL.HRT'] = param['RESULTS.DATA.TECHNICAL.HRT']
      ? new ResultRow(param['RESULTS.DATA.TECHNICAL.HRT'])
      : new ResultRow();

    this['RESULTS.DATA.TECHNICAL.OLR'] = param['RESULTS.DATA.TECHNICAL.OLR']
      ? new ResultRow(param['RESULTS.DATA.TECHNICAL.OLR'])
      : new ResultRow();

    this['RESULTS.DATA.TECHNICAL.DWV'] = param['RESULTS.DATA.TECHNICAL.DWV']
      ? new ResultRow(param['RESULTS.DATA.TECHNICAL.DWV'])
      : new ResultRow();

    this['RESULTS.DATA.TECHNICAL.DTV'] = param['RESULTS.DATA.TECHNICAL.DTV']
      ? new ResultRow(param['RESULTS.DATA.TECHNICAL.DTV'])
      : new ResultRow();

    this['RESULTS.DATA.TECHNICAL.BEE'] = param['RESULTS.DATA.TECHNICAL.BEE']
      ? new ResultRow(param['RESULTS.DATA.TECHNICAL.BEE'])
      : new ResultRow();

    this['RESULTS.DATA.TECHNICAL.AMF'] = param['RESULTS.DATA.TECHNICAL.AMF']
      ? new ResultRow(param['RESULTS.DATA.TECHNICAL.AMF'])
      : new ResultRow();

    this['RESULTS.DATA.TECHNICAL.ABF'] = param['RESULTS.DATA.TECHNICAL.ABF']
      ? new ResultRow(param['RESULTS.DATA.TECHNICAL.ABF'])
      : new ResultRow();
  }

  deepCopy() {
    return new OAPP(cloneDeep(this));
  }
}
